import { WebOutlined } from '@mui/icons-material'

import { useSelector } from '@tabeeb/store'
import { getCustomIframeTitle, getIsCustomIframeEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { TenantPermission } from '@tabeeb/enums'
import Routes from '@tabeeb/routes'
import { NavbarItem } from '@collaborate-health/uikit'

const CustomIFrameTab: React.FC = () => {
  const display = useSelector(
    (state) => getIsCustomIframeEnabled(state) && hasTenantPermission(state, TenantPermission.CustomIframeSettings)
  )
  const customFrameTitle = useSelector(getCustomIframeTitle)

  if (!display) {
    return null
  }

  return (
    <NavbarItem
      name={customFrameTitle && customFrameTitle?.length !== 0 ? customFrameTitle : 'Custom iframe'}
      href={Routes.customIframe}
      icon={<WebOutlined />}
    />
  )
}

export default CustomIFrameTab

